import React, { useState, useEffect } from 'react'
import { isCountryPhilippines } from './GlobalHelpers'
import { observer } from 'mobx-react'
import { defaults, trim, isNothing } from './utils/Utils'
import PropTypes from 'prop-types'

const Spinner = observer(props => {
    const defaultSpinnerClassName = isCountryPhilippines() ? 'loadingImagePH' : 'loadingImage'
    const defaultClassName = 'container'

    Spinner.propTypes = {
        spinnerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        style: PropTypes.object,
        spinnerStyle: PropTypes.object
    }

    const [className, setClassName] = useState(defaults(props.className, defaultClassName))

    const { spinnerClassName, spinnerStyle, ...customProps } = props

    const [spinner, setSpinner] = useState(false)

    useEffect(() => {
        // setTimeout(() => {
        //     setSpinner(true)
        // }, 100)
        setClassName(trim(`${defaultClassName} ${defaults(props.className, '')}`))
        return () => {
            setSpinner(false)
        }
    }, [props])

    return (
        <div {...customProps} className={className}>
            <div className="loadingWrapper">
               <div className={isNothing(spinnerClassName) ? defaultSpinnerClassName : spinnerClassName} style={isNothing(spinnerStyle) ? {} : spinnerStyle}></div>
            </div>
        </div>
    )
})

export default Spinner
